// extracted by mini-css-extract-plugin
export var copyableField = "_mr-4";
export var customerBadge = "_mr-0";
export var customerInfoTitle = "_mr-2";
export var details = "_mr-1";
export var dropdownContainer = "_mr-5";
export var dropdownImage = "_mr-6";
export var editAssigneeForm = "_mr-a";
export var editButton = "_mr-3";
export var email = "_mr-7";
export var hidden = "_mr-d";
export var input = "_mr-8";
export var saveButton = "_mr-b";
export var shopifyIcon = "_mr-c";
export var suggestionBadge = "_mr-e";
export var suggestionText = "_mr-f";
export var username = "_mr-9";